module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	fox.registerWidget('AdvancedFilter_ModelsFilter', {

		configure: function () {

			this.registerOptions('', {
				newSelect: true,
				widgets: {
					mcpSubscription_niches_siteNicheId: {
						widget: 'Control_Select_Dynamic',
						container: '.niches-wrapper',
						template: 'control_select_new',
						currentValuePlace :'.current-value',
						customOptions: [{title: 'Niches', value: '', selected: true}],
						'widgets.dl': {
							widget: 'Datalayer',
							method: 'Site.getAvailiableNiches'
						},
						'select.container': '.mc-form-field',
						'hooks.onStopPrepareSelectOptions': function () {
							fox.each(this.selectOptions, function (data) {
								data.title = data.title.ucfirst();
							});
						}
					},

					mcpSubscription_contentCategories_contentCategoryId: {
						widget: 'Control_Select_Dynamic',
						container: '.keywords-wrapper',
						template: 'control_select_new',
						currentValuePlace :'.current-value',
						customOptions: [{title: 'Keywords', value: '', selected: true}],
						'widgets.dl': {
							widget: 'Datalayer',
							method: 'category.get',
							limit: 100,
							transitParameters: {
								preset: 'mcpSite'
							}
						},
						'select.container': '.mc-form-field',
						'hooks.onStopPrepareSelectOptions': function () {
							fox.each(this.selectOptions, function (data) {
								data.title = data.title.ucfirst();
							});
						}
					},
					mcpSubscription_interactionFeatures_interactionFeatureId: {
						widget: 'Control_Select_Dynamic',
						container: '.features-wrapper',
						template: 'control_select_new',
						currentValuePlace :'.current-value',
						customOptions: [{title: 'Features', value: '', selected: true}],
						'widgets.dl': {
							widget: 'Datalayer',
							method: 'Site.getAvailiableInteractionFeatures'
						},
						'select.container': '.mc-form-field',
						'hooks.onStopPrepareSelectOptions': function () {
							fox.each(this.selectOptions, function (data) {
								data.title = data.title.ucfirst();
							});
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this.callParent('running', arguments);
		},

		_handleSearchSuccess: function (data, w, e) {
			w.responseData = data[0];
			w.renderResultList(w.responseData);
		},

		_handleInputChange: function (el, alias, w, e) {
			//console.log(arguments)
			var str = fox.trim(el.value);
			var ac = w.wom1('@parent');

			if (!str.length) {
				ac.loadAll();
				ac.clear();
			}
		},

		_searchListAdded: function () {
			var w = this.wom1('#clientId_name');

			w.listPointer = -1;

			if (w.responseData && w.responseData.length) {
				w.resultItems = w.resultList.dom('[fox-autocomplete-result-item]');

				if (w.getOption('loadAll')) {
					return;
				}

				w._showList();
				w.hightlightResult();

				return;
			}

			w._hideList();
			w.resultItems = [];
		},

	}, 'AdvancedFilter');
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/sitepage/filter.js
// module id = 202
// module chunks = 5